import { deepMerge } from 'www/utils'
import { REDIRECT_VALUES } from 'www/constants'
import { CLUB_EVENTS } from 'www/vue_components/common/Club/constants'
import { NAMESPACE } from 'www/modules/DoctorCardEmitter/constants'
import { getModuleOptionsInterface } from 'www/modules/DoctorCardEmitter/models'
import { changeHomeListener } from 'www/modules/DoctorCardEmitter/functions'

class DoctorCardEmitter {
  #options = getModuleOptionsInterface()

  get options() { return this.#options }

  set options(opts) { this.#options = deepMerge(getModuleOptionsInterface(), opts) }

  constructor(opts) {
    this.options = opts
    this._addEventListener()
  }

  _addEventListener() {
    document.addEventListener('click', this._clickEventListener.bind(this))

    window.addEventListener(
      CLUB_EVENTS.clubAppointmentTypeSelected,
      this._changeTabEventListener.bind(this),
    )
  }

  _clickEventListener(event) {
    const { target } = event

    if (!target) {
      return
    }

    const option = target.closest(NAMESPACE.selectorSelectOption)
    const formPRG = target.closest(NAMESPACE.prgSelector)

    if (formPRG) { // если обработчик ловит событие на PRG ссылке - редиректить через JS не нужно
      return
    }

    if (option) { // 'option' выбранного workplace врача в 'select'
      const card = target.closest(this.#options.cardSelector)
      const position = option.getAttribute(NAMESPACE.dataValue)

      this.options.hookOptionClick({ card, position })
    }
  }

  _changeTabEventListener({
    detail: {
      target,
      redirectValue,
      prevRedirectValue,
      scheduleType,
    },
  }) {
    changeHomeListener({
      target,
      redirectValue,
      cardSelector: this.#options.cardSelector,
      doctorPageType: this.#options.doctorPageType,
    })

    const isOnlineSelected = redirectValue === REDIRECT_VALUES.telemed
    const isTelemedMedtochkaSelected = redirectValue === REDIRECT_VALUES.telemedMedtochka
    const isOtherSelected = (
      redirectValue !== REDIRECT_VALUES.telemed && prevRedirectValue === REDIRECT_VALUES.telemed
    ) || (
      redirectValue !== REDIRECT_VALUES.telemedMedtochka
      && prevRedirectValue === REDIRECT_VALUES.telemedMedtochka
    )
    const isNeedRecalcCalendar = isOnlineSelected || isTelemedMedtochkaSelected || isOtherSelected
    const payload = {
      target,
      isOtherSelected, // true - если ушли с таба `Онлайн` (телемед)
      isOnlineSelected, // true - если перешли на таб `Онлайн` (телемед)
      isTelemedMedtochkaSelected,
      scheduleType,
      isNeedRecalcCalendar, // true - если необходим пересчёт слотов по времени пользователя или клиники
    }

    this.options.hookTabChange(payload)
  }
}

export default DoctorCardEmitter
